export const composeProtectButton = "Q5a";
export const composeSetPermissionDropDown = "R5a";
export default {composeProtectButton,composeSetPermissionDropDown};